/**
 * Possible values for "Pre-defined Variation" field in "Carousel Options" content type.
 */
var VARIATION = {
  DEFAULT: 'Default',
  CORPORATE: 'Corporate',
  FULL_WIDTH: 'Full width'
};

/**
 * Possible values for "Text Location" field in "Hero Card" content type.
 */
var GRID_ALIGNMENT = {
  TEXT_LEFT: 'Text Left',
  TEXT_RIGHT: 'Text Right',
  TEXT_CENTER: 'Center Bottom'
};

/**
 * Possible values for "Text placement" and "Text alignment" fields in "Carousel Options" content type.
 */
var TEXT_PLACEMENT = {
  LEFT: 'Left',
  RIGHT: 'Right',
  CENTER: 'Center'
};

/**
 * Possible values for "Text vertical alignment" field in "Carousel Options" content type.
 */
var VERTICAL_ALIGNMENT = {
  SPACE_BETWEEN: 'Space between',
  TOP: 'Top',
  BOTTOM: 'Bottom',
  CENTER: 'Center'
};
export default {
  VARIATION: VARIATION,
  GRID_ALIGNMENT: GRID_ALIGNMENT,
  TEXT_PLACEMENT: TEXT_PLACEMENT,
  VERTICAL_ALIGNMENT: VERTICAL_ALIGNMENT
};